import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedApproaches() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const approaches = ['Los tratamientos médicos solo ven el síntoma físico, ignorando la memoria celular del trauma transgeneracional.', 'La fe sin orden genera ansiedad, porque intentas pedir un milagro en una casa emocional que está desordenada.', 'Los consejos de "relajación" fallan porque no puedes relajar un sistema familiar que siente que tiene deudas pendientes con los ancestros.', 'Intentar forzar la concepción desde el miedo solo cierra más las puertas de tu sistema hormonal.'];
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-cream py-6 md:py-10 px-6" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-14">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-15">
            Por Qué Lo Que Intentaste No Funcionó
          </h2>

          <div className="space-y-4" data-id="element-16">
            {approaches.map((approach, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="flex gap-4 items-start bg-white rounded-2xl p-5 shadow-sm border border-rose/10" data-id="element-17">
                <XCircleIcon className="w-6 h-6 text-rose flex-shrink-0 mt-1" data-id="element-18" />
                <p className="font-sans text-lg text-brown/90 leading-relaxed" data-id="element-19">
                  {approach}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}